/* eslint-disable array-callback-return */
/* eslint-disable linebreak-style */
import { Component, createElement } from 'react';
import * as prodLytics from './analytics/prod';
import * as devLytics from './analytics/dev';

function isLocal(host) {
  return window.location.hostname === host;
}

function isDev() {
  return process.env.NODE_ENV !== 'production';
}

function isExcluded(exclude) {
  const { pathname } = window.location;

  return exclude.some((item) => pathname.match(item));
}

function isDoNotTrack(code) {
  if (code && (window.doNotTrack === '1' || navigator.doNotTrack === '1' || navigator.doNotTrack === 'yes' || navigator.msDoNotTrack === '1')) {
    return true;
  }
  return false;
}

const withGA = (codes, Router, { localhost = 'localhost', exclude = [] } = {}) => (Page) => {
  class WithAnalytics extends Component {
    constructor(props) {
      super(props);
      this.state = {
        analytics: undefined
      };
    }

    componentDidMount() {
      if (!isExcluded(exclude)) {
        // check if do not track
        codes.filter((v) => !v.name || v.name === 'analytics').map((v) => {
          window[`ga-disable-${v.codeId || v}`] = isDoNotTrack(v.codeId || v);
        });

        // check if it should track
        const shouldNotTrack = isLocal(localhost) || isDev();
        // check if it should use production or dev analytics
        const analytics = shouldNotTrack ? devLytics : prodLytics;

        // save possible previously defined callback
        const previousCallback = Router.onRouteChangeComplete;
        Router.onRouteChangeComplete = () => {
          setTimeout(() => {
            // log page
            codes.filter((v) => !v.name || v.name === 'analytics').map((v) => {
              analytics.pageview(v.codeId || v);
            });
          }, 0);
          // call previously defined callback if is a function
          if (typeof previousCallback === 'function') {
            previousCallback();
          }
        };

        this.setState({
          analytics
        });
      }
    }

    render() {
      return createElement(Page, {
        ...this.props,
        analytics: this.state.analytics
      });
    }
  }

  return WithAnalytics;
};

export function event(data) {
  // check if it should track
  const shouldNotTrack = isLocal('localhost') || isDev();
  // check if it should use production or dev analytics
  const analytics = shouldNotTrack ? devLytics : prodLytics;

  analytics.event(data);
}

export default withGA;
